import React from 'react';

function Footer() {
  return (
    <footer className="bg-white pt-5 border-top">
      <div className="container">
        <div className="row text-start text-dark">
          <div className="col-md-2 mb-4">
            <h6 className="fw-bold text-uppercase "style={{color:'#38C6C3'}}>Privacy Policy</h6>
            <a href="#" className=" d-block" style={{ color: '#0f174f' }}>Policy</a>
          </div>
          <div className="col-md-2 mb-4">
            <h6 className="fw-bold text-uppercase " style={{color:'#38C6C3'}}>Terms of Use</h6>
            <a href="#" className=" d-block" style={{ color: '#0f174f' }}>Ts & Cs</a>
          </div>
          <div className="col-md-2 mb-4">
            <h6 className="fw-bold text-uppercase "style={{color:'#38C6C3'}}>Vacancies</h6>
            <a href="#" className=" d-block" style={{ color: '#0f174f' }}>Click here to view jobs</a>
          </div>
          <div className="col-md-2 mb-4">
            <h6 className="fw-bold text-uppercase "style={{color:'#38C6C3'}}>Follow</h6>
            <div className="d-flex gap-2">
              <a href="#"><i className="bi bi-facebook fs-4 " style={{ color: '#0f174f' }}></i></a>
              <a href="#"><i className="bi bi-linkedin fs-4 " style={{ color: '#0f174f' }}></i></a>
              <a href="#"><i className="bi bi-instagram fs-4 " style={{ color: '#0f174f' }}></i></a>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <h6 className="fw-bold text-uppercase "style={{color:'#38C6C3'}}>Contact Us</h6>
            <p className="mb-0"><strong>Sales</strong><br />
              <a href="mailto:sales@gplat.co.za" className="" style={{ color: '#0f174f' }}>sales@gplat.co.za</a>
            </p>
            <p className="mb-0 mt-2"><strong>Support</strong><br />
              <a href="mailto:support@gplat.co.za" className="" style={{ color: '#0f174f' }}>support@gplat.co.za</a>
            </p>
            <p className="mb-0 mt-2"><strong>Call Center</strong><br />
              <span className="" style={{ color: '#0f174f' }}>0861 777 889</span>
            </p>
          </div>
        </div>
      </div>

      <div className="text-white text-center py-3 mt-3" style={{ background: 'linear-gradient(to right, #38C6C3,rgb(56, 198, 153))' }}>
        <p className="mb-1">FTTBSA, a product of Global Platinum Solutions.</p>
        <strong>Designed by DM333</strong>
        {/* <div className="d-flex justify-content-center mt-2">
          <img
            src="/assets/payment-logos.png"
            alt="payment options"
            height="35"
          />
        </div> */}
      </div>
    </footer>
  );
}

export default Footer;
